// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateBillingInvoiceItemPayload,
    Invoice,
    ObjectNoResponse,
    ProviderInvoiceSortType,
    ProviderShortUrl,
    SupportInvoiceSortType,
    SupportShortUrl,
    UpdateBillingInvoicePayload,
    CreateBillingInvoiceItemPayloadToJSON,
    UpdateBillingInvoicePayloadToJSON,
    InvoiceFromJSON,
    ObjectNoResponseFromJSON,
    ProviderShortUrlFromJSON,
    SupportShortUrlFromJSON,
} from '../models';

export interface GetInvoiceCheckoutUrlRequest {
    id: string;
}

export interface GetProviderInvoiceRequest {
    id: string;
}

export interface GetProviderInvoiceCheckoutUrlRequest {
    id: string;
}

export interface GetSupportInvoiceRequest {
    id: string;
}

export interface ListProviderInvoicesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderInvoicesOrderEnum>;
    filterClaimId?: Array<string>;
    filterGroupId?: Array<string>;
    filterAmount?: Array<string>;
    filterInvoiceStatus?: Array<string>;
    filterInvoiceType?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterLatestResourceInGroup?: string;
    sort?: Array<ProviderInvoiceSortType>;
}

export interface ListSupportInvoicesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportInvoicesOrderEnum>;
    filterClaimId?: Array<string>;
    filterGroupId?: Array<string>;
    filterAmount?: Array<string>;
    filterInvoiceStatus?: Array<string>;
    filterInvoiceType?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterLatestResourceInGroup?: string;
    filterClaimType?: ListSupportInvoicesFilterClaimTypeEnum;
    sort?: Array<SupportInvoiceSortType>;
}

export interface PostInvoiceCheckoutUrlRequest {
    id: string;
}

export interface PostProviderInvoiceItemRequest {
    id: string;
    createBillingInvoiceItemPayload: CreateBillingInvoiceItemPayload;
}

export interface PostSupportInvoiceDisableCheckoutRequest {
    id: string;
}

export interface PostSupportInvoiceDisablePatientCollectionsRequest {
    id: string;
}

export interface PostSupportInvoiceEnablePatientCollectionsRequest {
    id: string;
}

export interface PostSupportInvoiceItemRequest {
    id: string;
    createBillingInvoiceItemPayload: CreateBillingInvoiceItemPayload;
}

export interface PutSupportInvoiceRequest {
    id: string;
    updateBillingInvoicePayload: UpdateBillingInvoicePayload;
}

/**
 * no description
 */
export class InvoiceApi extends runtime.BaseAPI {

    /**
     * Get checkout url for invoice
     * Get checkout url for invoice
     */
    async getInvoiceCheckoutUrlRaw(requestParameters: GetInvoiceCheckoutUrlRequest): Promise<runtime.ApiResponse<SupportShortUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getInvoiceCheckoutUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:invoice"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/invoice/{id}/checkout_url`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportShortUrlFromJSON(jsonValue));
    }

    /**
     * Get checkout url for invoice
     * Get checkout url for invoice
     */
    async getInvoiceCheckoutUrl(requestParameters: GetInvoiceCheckoutUrlRequest): Promise<SupportShortUrl> {
        const response = await this.getInvoiceCheckoutUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an invoice
     * Get an invoice
     */
    async getProviderInvoiceRaw(requestParameters: GetProviderInvoiceRequest): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderInvoice.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:invoice"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/invoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Gets an invoice
     * Get an invoice
     */
    async getProviderInvoice(requestParameters: GetProviderInvoiceRequest): Promise<Invoice> {
        const response = await this.getProviderInvoiceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get checkout url for invoice
     * Get checkout url for invoice
     */
    async getProviderInvoiceCheckoutUrlRaw(requestParameters: GetProviderInvoiceCheckoutUrlRequest): Promise<runtime.ApiResponse<ProviderShortUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderInvoiceCheckoutUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:invoice"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/invoice/{id}/checkout_url`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderShortUrlFromJSON(jsonValue));
    }

    /**
     * Get checkout url for invoice
     * Get checkout url for invoice
     */
    async getProviderInvoiceCheckoutUrl(requestParameters: GetProviderInvoiceCheckoutUrlRequest): Promise<ProviderShortUrl> {
        const response = await this.getProviderInvoiceCheckoutUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an invoice
     * Get an invoice
     */
    async getSupportInvoiceRaw(requestParameters: GetSupportInvoiceRequest): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportInvoice.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:invoice", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/invoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Gets an invoice
     * Get an invoice
     */
    async getSupportInvoice(requestParameters: GetSupportInvoiceRequest): Promise<Invoice> {
        const response = await this.getSupportInvoiceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of invoices
     * Get a list of invoices
     */
    async listProviderInvoicesRaw(requestParameters: ListProviderInvoicesRequest): Promise<runtime.ApiResponse<Array<Invoice>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterGroupId) {
            queryParameters['filterGroupId'] = requestParameters.filterGroupId;
        }

        if (requestParameters.filterAmount) {
            queryParameters['filterAmount'] = requestParameters.filterAmount;
        }

        if (requestParameters.filterInvoiceStatus) {
            queryParameters['filterInvoiceStatus'] = requestParameters.filterInvoiceStatus;
        }

        if (requestParameters.filterInvoiceType) {
            queryParameters['filterInvoiceType'] = requestParameters.filterInvoiceType;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterLatestResourceInGroup !== undefined) {
            queryParameters['filterLatestResourceInGroup'] = requestParameters.filterLatestResourceInGroup;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:invoice"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/invoice`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * Gets a list of invoices
     * Get a list of invoices
     */
    async listProviderInvoices(requestParameters: ListProviderInvoicesRequest): Promise<Array<Invoice>> {
        const response = await this.listProviderInvoicesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of invoices
     * Get a list of invoices
     */
    async listSupportInvoicesRaw(requestParameters: ListSupportInvoicesRequest): Promise<runtime.ApiResponse<Array<Invoice>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterGroupId) {
            queryParameters['filterGroupId'] = requestParameters.filterGroupId;
        }

        if (requestParameters.filterAmount) {
            queryParameters['filterAmount'] = requestParameters.filterAmount;
        }

        if (requestParameters.filterInvoiceStatus) {
            queryParameters['filterInvoiceStatus'] = requestParameters.filterInvoiceStatus;
        }

        if (requestParameters.filterInvoiceType) {
            queryParameters['filterInvoiceType'] = requestParameters.filterInvoiceType;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterLatestResourceInGroup !== undefined) {
            queryParameters['filterLatestResourceInGroup'] = requestParameters.filterLatestResourceInGroup;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:invoice", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/invoice`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceFromJSON));
    }

    /**
     * Gets a list of invoices
     * Get a list of invoices
     */
    async listSupportInvoices(requestParameters: ListSupportInvoicesRequest): Promise<Array<Invoice>> {
        const response = await this.listSupportInvoicesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get checkout url for invoice
     * Get checkout url for invoice
     */
    async postInvoiceCheckoutUrlRaw(requestParameters: PostInvoiceCheckoutUrlRequest): Promise<runtime.ApiResponse<SupportShortUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postInvoiceCheckoutUrl.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:invoice"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/invoice/{id}/checkout_url`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportShortUrlFromJSON(jsonValue));
    }

    /**
     * Get checkout url for invoice
     * Get checkout url for invoice
     */
    async postInvoiceCheckoutUrl(requestParameters: PostInvoiceCheckoutUrlRequest): Promise<SupportShortUrl> {
        const response = await this.postInvoiceCheckoutUrlRaw(requestParameters);
        return await response.value();
    }

    /**
     * Add line item to invoice
     * Add line item to invoice
     */
    async postProviderInvoiceItemRaw(requestParameters: PostProviderInvoiceItemRequest): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderInvoiceItem.');
        }

        if (requestParameters['createBillingInvoiceItemPayload'] === null || requestParameters['createBillingInvoiceItemPayload'] === undefined) {
            throw new runtime.RequiredError('createBillingInvoiceItemPayload','Required parameter requestParameters.createBillingInvoiceItemPayload was null or undefined when calling postProviderInvoiceItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:invoice"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/invoice/{id}/items`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBillingInvoiceItemPayloadToJSON(requestParameters['createBillingInvoiceItemPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Add line item to invoice
     * Add line item to invoice
     */
    async postProviderInvoiceItem(requestParameters: PostProviderInvoiceItemRequest): Promise<Invoice> {
        const response = await this.postProviderInvoiceItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable checkout url for invoice
     * Disable checkout url for invoice
     */
    async postSupportInvoiceDisableCheckoutRaw(requestParameters: PostSupportInvoiceDisableCheckoutRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportInvoiceDisableCheckout.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:invoice"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/invoice/{id}/disable_checkout`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable checkout url for invoice
     * Disable checkout url for invoice
     */
    async postSupportInvoiceDisableCheckout(requestParameters: PostSupportInvoiceDisableCheckoutRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportInvoiceDisableCheckoutRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable patient collections
     * Enable patient collections
     */
    async postSupportInvoiceDisablePatientCollectionsRaw(requestParameters: PostSupportInvoiceDisablePatientCollectionsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportInvoiceDisablePatientCollections.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/invoice/{id}/disable_patient_collections`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Enable patient collections
     * Enable patient collections
     */
    async postSupportInvoiceDisablePatientCollections(requestParameters: PostSupportInvoiceDisablePatientCollectionsRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportInvoiceDisablePatientCollectionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enable patient collections
     * Enable patient collections
     */
    async postSupportInvoiceEnablePatientCollectionsRaw(requestParameters: PostSupportInvoiceEnablePatientCollectionsRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportInvoiceEnablePatientCollections.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/invoice/{id}/enable_patient_collections`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Enable patient collections
     * Enable patient collections
     */
    async postSupportInvoiceEnablePatientCollections(requestParameters: PostSupportInvoiceEnablePatientCollectionsRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportInvoiceEnablePatientCollectionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Add line item to invoice
     * Add line item to invoice
     */
    async postSupportInvoiceItemRaw(requestParameters: PostSupportInvoiceItemRequest): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportInvoiceItem.');
        }

        if (requestParameters['createBillingInvoiceItemPayload'] === null || requestParameters['createBillingInvoiceItemPayload'] === undefined) {
            throw new runtime.RequiredError('createBillingInvoiceItemPayload','Required parameter requestParameters.createBillingInvoiceItemPayload was null or undefined when calling postSupportInvoiceItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:invoice", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/invoice/{id}/items`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBillingInvoiceItemPayloadToJSON(requestParameters['createBillingInvoiceItemPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Add line item to invoice
     * Add line item to invoice
     */
    async postSupportInvoiceItem(requestParameters: PostSupportInvoiceItemRequest): Promise<Invoice> {
        const response = await this.postSupportInvoiceItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Add line item to invoice
     * Add line item to invoice
     */
    async putSupportInvoiceRaw(requestParameters: PutSupportInvoiceRequest): Promise<runtime.ApiResponse<Invoice>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putSupportInvoice.');
        }

        if (requestParameters['updateBillingInvoicePayload'] === null || requestParameters['updateBillingInvoicePayload'] === undefined) {
            throw new runtime.RequiredError('updateBillingInvoicePayload','Required parameter requestParameters.updateBillingInvoicePayload was null or undefined when calling putSupportInvoice.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:invoice", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/invoice/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBillingInvoicePayloadToJSON(requestParameters['updateBillingInvoicePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceFromJSON(jsonValue));
    }

    /**
     * Add line item to invoice
     * Add line item to invoice
     */
    async putSupportInvoice(requestParameters: PutSupportInvoiceRequest): Promise<Invoice> {
        const response = await this.putSupportInvoiceRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderInvoicesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportInvoicesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportInvoicesFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
